import { render, staticRenderFns } from "./product-filters-desktop.vue?vue&type=template&id=43d5f6a1"
import script from "./product-filters-desktop.vue?vue&type=script&lang=js"
export * from "./product-filters-desktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports